module.exports = __webpack_public_path__ + "img/cheese-realm-hero.9e1e9a8d.png";